<template>
  <header>
    <b-container>
      <b-row class="head">
        <b-col cols="3" class="info text-left">
          
          <img src="../assets/logo.svg" @click="home()" style="cursor:pointer" />
        </b-col>
        <b-col cols="9" class>
          
          <div class="profile" @click="show = !show" v-click-outside="onClose" >
            <img :src="'//api.game.skillslab.center' + user.icon" alt />
            <div class="name d-none d-sm-block">{{user.last_name}} {{user.first_name}}</div>
            <i class="las la-angle-down" style="margin-left:3px; font-size:12px; padding-top:14px;"></i>
            <transition name="fade">
              <div class="dropdown" v-if="show" >
                <ul>
                  <li @click.stop="to_edit">
                    <i class="las la-cog"></i>Редактировать
                  </li>
                  <li @click.stop="exit">
                    <i class="las la-sign-out-alt"></i>Выйти
                  </li>
                </ul>
              </div>
            </transition>
          </div>
          <div class="user_rating" v-b-tooltip.hover title="Столько звезд Вам поставили другие пользователи. Вы их можете обменять на ответы автора">
            <i class="las la-star"></i> {{user.coin}}
          </div>
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>
<script>
import API from '@/api'
export default {
  name: "Header",
  data() {
    return {
      user: this.$store.getters.userData,
      show: false
    };
  },
  components: {},
  mounted() {
    this.$store.dispatch("user_data")
  },
  methods: {
    home()
    {
     
      if(this.$route.name != 'Courses')
      {
        this.$store.commit('setPage', {page: 0, onboarding: true})
        this.$router.push({ path: '/courses' })
      }
      
      
      
    },
    to_edit()
    {   
      this.$router.push('/editUser')
    },
    exit()
    {
      this.$store.dispatch("logout");
    },
    onClose: function(event) {
      // do something - probably hide the dropdown menu / modal etc.
      this.show = false;
    },
    openMenu() {
      document.getElementById("Nav").style.display = "block";
    }
  },
  props: {},
  directives: {
    'click-outside': {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
        	const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          
          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
        
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
          	binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
			},
      
      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
};
</script>
<style scoped>
header {
  z-index: 1;
  display: table;
  width: 100%;
  padding: 15px 0;
  border-bottom: 2px solid #dbdbdb;
}
.profile {
  display: table;
  float: right;
  position: relative;
  cursor: pointer;
}
.profile img {
  width: 30px;
  float: left;
  border-radius: 15px;
}
.profile .name {
  float: left;
  margin-top: 6px;
  margin-left: 10px;
}
.dropdown {

  display: table;
  background-color: white;
  position: absolute;
  right: 0;
  margin-top: 10px;
  -webkit-box-shadow: 0 5px 20px 1px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0 5px 20px 1px rgba(0, 0, 0, 0.08);
  box-shadow: 0 5px 20px 1px rgba(0, 0, 0, 0.08);
  z-index: 1;
}

.dropdown ul {
  padding: 0;
  margin-bottom: 0;
}
.dropdown li:last-child {
  border: none;
}
.dropdown li {
  display: block;
  padding: 10px 20px;
  border-bottom: 2px solid #dbdbdb;
  cursor: pointer;
  width: max-content;   
  width: intrinsic;           /* Safari/WebKit используют нестандартное имя */
  width: -moz-max-content;    /* Firefox/Gecko */
  width: -webkit-max-content;
}
.dropdown li i {
  color: #08a2dc;
  margin-right: 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.user_rating
{
  float: right;
  font-size: 18px;
  margin-right: 10px;
  margin-top: 3px;
}
.profile
{
  float: right;
}
.user_rating i{
  color: #08a2dc;;
}
</style>